// import { useNavigate } from 'react-router-dom';
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
// import MDAlert from "components/MDAlert";
import MDButton from 'components/MDButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Oval } from 'react-loader-spinner';
import Select from 'react-select';
import { Checkbox } from '@mui/material';
import * as moment from 'moment';
// import MDInput from "components/MDInput";
import * as service from '../../services/service';

function AdvocateAllocations() {
    const [data, setData] = useState([]);
    const [advocateData, setAdvocateData] = useState([]);
    const [advocateId, setAdvocateId] = useState('');
    const [courtData, setCourtData] = useState([]);
    const [caseTypeData, setCaseTypeData] = useState([]);
    const [caseData, setCaseData] = useState([]);
    const [caseDetails, setCaseDetails] = useState([]);
    const [caseDataForDropdown, setCaseDataForDropdown] = useState([]);
    const [courtId, setCourtId] = useState('');
    const [caseTypeId, setCaseTypeId] = useState('');
    const [caseId, setCaseId] = useState('');
    const [caseStageIds, setCaseStageIds] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    // const navigate = useNavigate();

    const getCourts = () => {
        fetch(
            service.COURTS_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.courtId, label: item.court }));
                setCourtData(data2);
            });
    };

    const getCaseTypes = (id) => {
        fetch(
            service.GET_CASE_TYPE_BY_COURT_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CourtId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.caseTypeId, label: item.caseType }));
                setCaseTypeData(data2);
            });
    };

    const getCaseDetails = (id) => {
        const errs = {};
        fetch(
            service.GET_CASE_DETAILS_BY_CASE_TYPE_ID,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CaseTypeId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                setCaseData(result);
                const data2 = result.map((item) => ({ value: item.caseId, label: item.caseNo }));
                setCaseDataForDropdown(data2);
            })
            .catch(err => {
                if (err) {
                    errs[".invalid"] = err;
                    setErrors(err);
                };
            });
    };

    const getAdvocates = () => {
        fetch(
            service.GET_ADVOCATES,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.userId, label: item.fullName }));
                setAdvocateData(data2);
            });
    };

    const getDetails = (id) => {
        if (id > 0) {
            fetch(
                service.GET_ADVOCATE_ALLOCATIONS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CaseTypeId: caseTypeId.value,
                        CaseId: id,
                        UserId: advocateId.value,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    setData(result);
                    result.forEach((element, index) => {
                        caseStageIds[index] = element.caseStageId;
                        setCaseStageIds([...caseStageIds]);
                        isSelected[index] = element.isSelected;
                        setIsSelected([...isSelected]);
                    });
                })
                .catch(err => {
                    if (err) {
                        setErrors(err);
                    };
                });
        }
    };
    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!advocateId) {
            isValid = false;
            errs[".legalAdvisorId"] = "Please select advocate";
        }
        if (!courtId) {
            isValid = false;
            errs[".courtId"] = "Please select court";
        }
        if (!caseTypeId) {
            isValid = false;
            errs[".caseTypeId"] = "Please select case type";
        }
        if (!caseId) {
            isValid = false;
            errs[".caseId"] = "Please select case";
        }
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".districtId"] = "Please select district";
        }
        setErrors(errs);
        return isValid;
    }

    const submitHandler = e => {
        if (validate()) {
            // eslint-disable-next-line
            console.log(caseStageIds); // do not remove
            e.preventDefault();
            const errs = {};
            setLoading(true);
            let flag = true;
            fetch(
                service.DELETE_ADVOCATE_ALLOCATIONS,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        CaseId: caseId.value,
                        UserId: advocateId.value,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        // navigate('/supplier/suppliermaterialmap');
                    }
                    else if (result.messageType === 'Success') {
                        caseStageIds.forEach((element, index) => {
                            if (isSelected[index] === true) {
                                fetch(
                                    service.ADD_ADVOCATE_ALLOCATION,
                                    {
                                        method: 'POST',
                                        headers: {
                                            'Accept': 'application/json',
                                            'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({
                                            CaseId: caseId.value,
                                            CaseStageId: element,
                                            UserId: advocateId.value,
                                            AddedBy: JSON.parse(sessionStorage.getItem('userData')).userId,
                                        })
                                    })
                                    .then(resp => resp.json())
                                    .then(respo => {
                                        if (respo.messageType === 'Failed') {
                                            flag = false;
                                            // eslint-disable-next-line
                                            alert(respo.message);
                                            // navigate('/supplier/suppliermaterialmap');
                                        }
                                        else {
                                            flag = false;
                                            errs[".invalid"] = respo.message.message;
                                            setErrors(errs);
                                        }
                                    });
                            }
                        });
                        if (flag) {
                            // eslint-disable-next-line
                            alert("Data Saved Successfully");
                            // navigate('/masters/operationmachinemap');
                            window.location.reload(false);
                        }
                    }
                });
            setLoading(false);
        }
    }

    const advocateChangeHandler = (ev) => {
        setAdvocateId(ev);
        setData([]);
        setCaseStageIds([]);
        setIsSelected([]);
    }
    const courtChangeHandler = (ev) => {
        setCourtId(ev);
        setCaseTypeId(null);
        getCaseTypes(ev.value);
        setData([]);
        setCaseStageIds([]);
        setIsSelected([]);
    }
    const caseTypeChangeHandler = (ev) => {
        setCaseTypeId(ev);
        setData([]);
        setCaseStageIds([]);
        setIsSelected([]);
        getCaseDetails(ev.value);
    }
    const CaseChangeHandler = (ev) => {
        setCaseId(ev);
        const details = caseData.find(x => x.caseId === ev.value);
        setCaseDetails(details);
        getDetails(ev.value);
    }
    useEffect(() => {
        setLoading(true);
        getCourts();
        getAdvocates();
        setLoading(false);
    }, []);

    const handleCheckboxChange = (checked, index) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);
    }

    const clearHandler = () => {
        setAdvocateId(null);
        setCourtId(null);
        setCaseTypeId(null);
        setCaseId(null);
        setData([]);
        setCaseStageIds([]);
        setIsSelected([]);
        setCaseData([]);
        setErrors('');
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Advocate Allocation
                                </MDTypography>
                            </MDBox>
                            <br />
                            <Card style={{ alignItems: 'center' }}>

                                <Table aria-label="simple table">
                                    <TableRow>
                                        <TableCell align='right' style={{ fontSize: '12px', width: '20%' }}>Advocate :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '25%' }}>
                                            <Select
                                                options={advocateData}
                                                name="advocate"
                                                value={advocateId}
                                                onChange={advocateChangeHandler}
                                                placeholder="Select Advocate"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".advocateId"]}</div>
                                        </TableCell>
                                        <TableCell align='right' style={{ fontSize: '12px', width: '20%' }}>Court :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px', width: '25%' }}>
                                            <Select
                                                options={courtData}
                                                name="court"
                                                value={courtId}
                                                onChange={courtChangeHandler}
                                                placeholder="Select Court"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".courtId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align='right' style={{ fontSize: '12px' }}>Case Type :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px' }}>
                                            <Select
                                                options={caseTypeData}
                                                name="caseType"
                                                value={caseTypeId}
                                                onChange={caseTypeChangeHandler}
                                                placeholder="Select Case Type"
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseTypeId"]}</div>
                                        </TableCell>
                                        <TableCell align='right' style={{ fontSize: '12px' }}>Case :</TableCell>
                                        <TableCell align='left' style={{ fontSize: '12px' }}>
                                            <Select
                                                name="Case"
                                                options={caseDataForDropdown} placeholder="Select Case"
                                                value={caseId}
                                                onChange={CaseChangeHandler}
                                                isSearchable
                                                styles={selectStyles}
                                            />
                                            <div style={{ fontSize: '12px', color: 'red' }}>{errors[".caseId"]}</div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Case No : {caseDetails ? caseDetails.caseNo : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Notice No : {caseDetails ? caseDetails.noticeNo : ""}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Notice Date : {caseDetails ? moment(caseDetails.noticeDate).format('DD/MM/YYYY') : ""}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Project : {caseDetails ? caseDetails.project : ""}
                                        </TableCell>
                                    </TableRow>                                  
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Case Subject : {caseDetails ? caseDetails.caseSubject : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Complainant : {caseDetails ? caseDetails.complainant : ""}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil IDC : {caseDetails ? caseDetails.civilIDC : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil CEO : {caseDetails ? caseDetails.civilCEO : ""}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil SEO : {caseDetails ? caseDetails.civilSEO : ''}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '14px' }}>
                                            Civil Division : {caseDetails ? caseDetails.civilDivision : ""}
                                        </TableCell>
                                    </TableRow>                                   
                                </Table>
                                <br />
                                {loading ? <Oval
                                    heigth="100"
                                    width="100"
                                    color='grey'
                                    ariaLabel='loading'
                                /> :
                                    <TableContainer component={Paper} style={{ width: '90%', alignSelf: 'center', }}>
                                        <Table aria-label="simple table">
                                            <TableRow>
                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                <TableCell style={{ fontWeight: 'bold' }}>Case Stage</TableCell>
                                            </TableRow>
                                            <TableBody>
                                                {data.map((row, index) => (
                                                    <TableRow
                                                        key={row.caseStageId}
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell>
                                                            <Checkbox checked={isSelected[index] || false}
                                                                onChange={(e) => handleCheckboxChange(e.target.checked, index)} id="chkSelect" />
                                                        </TableCell>
                                                        <TableCell>{row.caseStage}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                }
                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".districtId"]}</div>
                                <MDBox mt={4} mb={1} textAlign="center">
                                    {loading ? <Oval
                                        heigth="20"
                                        width="20"
                                        color='grey'
                                        ariaLabel='loading'
                                    /> :
                                        <div>
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <MDButton color="info" onClick={clearHandler}>
                                                Clear
                                            </MDButton>
                                        </div>
                                    }
                                    {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                </MDBox>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>
                <Footer />
            </div>
        </DashboardLayout>
    );
}
export default AdvocateAllocations;